import { APIService } from "../api-service";

export type LeadDestination = { id: string; name: string };
export type AdminLeadDestination = LeadDestination & {
  isActive: boolean;
  counsellorCount: number;
};

export class LeadDestinationsService extends APIService {
  static readonly BASE_URL = `${this.API_PREFIX_URL}/lead-destinations`;
  static readonly ADMIN_URL = `${this.API_PREFIX_URL}/admin/lead-destinations`;

  static getAll = async (): Promise<LeadDestination[]> => {
    const res = await this.get<{ data: { items: LeadDestination[] } }>(
      `${this.BASE_URL}/`,
      { withAuthToken: true },
    );
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (res as any).data?.data?.items ?? (res as any).data?.items ?? [];
  };

  static create = (name: string) =>
    this.post<{ data: { item: LeadDestination } }>(
      `${this.ADMIN_URL}/`,
      { name },
      { withAuthToken: true },
    );

  static deleteDestination = (id: string) =>
    this.delete(`${this.ADMIN_URL}/${id}`, { withAuthToken: true });

  static getAdminAll = async (): Promise<AdminLeadDestination[]> => {
    const res = await this.get<{ data: { items: AdminLeadDestination[] } }>(
      `${this.ADMIN_URL}/`,
      { withAuthToken: true },
    );
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (res as any).data?.data?.items ?? (res as any).data?.items ?? [];
  };

  static reactivate = (id: string) =>
    this.patch(`${this.ADMIN_URL}/${id}/reactivate`, {}, { withAuthToken: true });
}

export type { LeadDestination as LeadDestinationType };
